import {Tooltip} from "./styledComponents";
import React, {useState} from "react";
import {LoadingButton} from "@mui/lab";
import utils from "../lib/utils";
import {darken, styled} from "@mui/material/styles";
import {ButtonProps} from "@mui/material/Button";
import {SxProps} from "@mui/material";

const ColorButtonRaw = styled(LoadingButton)(({theme}) => ({
    '&:disabled': {
        color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.26)" : "rgba(0, 0, 0, 0.26)",
        boxShadow: "none",
        backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)",
    },
}));


type Props = {
    label: string,
    labelPlacement?: "bottom" | "top" | "left" | "right",
    color?: string,
    backgroundColor?: string,
    hoverColor?: string,
    sx?: any,
    style?: React.CSSProperties,
    buttonStyle?: React.CSSProperties,
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
               setLoading: React.Dispatch<React.SetStateAction<boolean>>
    ) => Promise<void>,
} & ButtonProps;

export const ColorButton: React.FC<Props> = (
        {
            label,
            labelPlacement = "right",
            color,
            backgroundColor,
            hoverColor = backgroundColor ? darken(backgroundColor, 0.2) : "",
            sx: rootSx,
            style,
            buttonStyle,
            onClick,
            ...props
        }) => {

    const sx: SxProps = {
        "&:disabled": {
            backgroundColor: 'initial'
        },
        // backgroundColor: "red !important",
        // bgcolor: "red !important",
    };

    if (color) {
        sx["color"] = color;
    }

    if (backgroundColor) {
        sx["backgroundColor"] = backgroundColor;
    }

    if (hoverColor) {
        sx['&:hover'] = {
            backgroundColor: hoverColor,
        }
    }

    const [loading, setLoading] = useState(false);

    return <Tooltip
            placement={labelPlacement}
            title={label}
    >
    <span
            style={{
                cursor: "pointer",
                ...style,
                ...rootSx,
            }}
    >
    <ColorButtonRaw
            loading={loading}
            onClick={async event => {
                setLoading(true);
                await utils.sleep(1000)
                if (onClick) {
                    onClick(event, setLoading);
                }
            }}
            sx={{...sx, ...buttonStyle}}
            {...props}
    />
          </span>
    </Tooltip>
};

//Example usage:

//    <ColorButton
//        onClick={this.createRoom}
//        endIcon={<AddCircleOutline/>}
//        loading={loading}
//     loadingPosition="end"
//     variant="contained"
//     color={"error"}
//     disabled={isInvitee}
//     label={isInvitee ? "Please finalize your registration to create your own rooms" : ""}
//   >
//     Create
//   </ColorButton>
